import React from 'react';

function BotaoAlertCodutor({ primeiroNome, onAssociado, onOutro, onVoltar }) {
  const btnVoltar = {
    width: '28px',
    height: '28px',
    borderRadius: '7px',
    border: '1px solid #2e3748',
    background: 'rgba(20, 26, 35, 0.82)',
    color: '#b6c1d4',
    fontWeight: 700,
    fontSize: '13px',
    cursor: 'pointer',
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
    transition: 'all .2s ease',
    opacity: 0.9
  };

  const descricao = {
    width: '100%',
    textAlign: 'center',
    color: '#e5e7eb',
    fontWeight: 700,
    fontSize: '15px',
    marginTop: '2px',
    marginBottom: '2px'
  };

  const btn = {
    flex: 1,
    minWidth: '90px',
    width: '100%',
    maxWidth: '180px',
    height: '44px',
    borderRadius: '12px',
    border: '1px solid #3a4252',
    background: '#161b24',
    color: '#dce3f1',
    fontWeight: 700,
    letterSpacing: '0.3px',
    cursor: 'pointer',
    transition: 'all .2s ease',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, justifyContent: 'center', width: '100%' }}>
      <div>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
            <button type="button" onClick={onVoltar} style={btnVoltar}>
            ←
            </button>
            <div style={descricao}>
                Quem estava conduzindo o veículo?
            </div>
        </div>

      </div>

      <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap', width: '100%' }}>
        <button type="button" onClick={onAssociado} style={{ ...btn, textTransform: 'capitalize' }}>
          Associado {primeiroNome}
        </button>
        <button type="button" onClick={onOutro} style={btn}>
          Outro
        </button>
      </div>
    </div>
  );
}

export { BotaoAlertCodutor };
export default BotaoAlertCodutor;